import { render, staticRenderFns } from "./SingleNetwork.vue?vue&type=template&id=0245e1cb&"
import script from "./SingleNetwork.vue?vue&type=script&lang=js&"
export * from "./SingleNetwork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports